import { Component } from '@angular/core';
import { QueryOptions } from '../../query-builder/query-builder.component';
import { ShadowPageBaseComponent } from '../shadow-page-base.component';

@Component({
  selector: 'dcc-devices-insights',
  templateUrl: '../shadow-page-base.component.html',
  styleUrls: ['../shadow-page-base.component.scss'],
})
export class DevicesInsightsComponent extends ShadowPageBaseComponent {
  override queryOptions: QueryOptions = {
    name: 'All Devices',
    showAdvanced: true,
  };
}
